<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('partnersDeposits.partnersDeposits')"
          :description="$t('partnersDeposits.FromHereYouCanControlPartnerDeposits')"
        />
        <indexTable
          :searchText="$t('partnersDeposits.SearchForAnOperation')"
          :emptyTableText="$t('partnersDeposits.NoDeposits')"
          :buttonRole="$checkRole('partners_deposits_add')"
          :emptyTableSubText="$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('orders.situation'), value: '' },
            { title: $t('orders.all'), value: '' },
            { title: $t('invoices.draft'), value: 0 },
            { title: $t('invoices.approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('partnersDeposits.Process'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'partner_id',
              title: $t('partnersDeposits.PartnerName'),
              type: 'link',
              to: 'partner',
              sort: true,
              link: true
            },
            {
              column: 'safe_id',
              title: $t('partnersDeposits.Treasury'),
              type: 'link',
              to: 'safe',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('partnersDeposits.date'),
              type: 'text',
              sort: true
            },
            {
              column: 'description',
              title: $t('partnersDeposits.AndThatIsAbout'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('partnersDeposits.cost'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: 'اسم المسئول',
              type: 'text',
              sort: true,
              icon: 'usd-square'
            },
            {
              column: 'status',
              title: $t('bills.situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('invoices.draft'), value: 0, color: 'dark' },
                { title: $t('invoices.approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('partnersDeposits.actions'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('partners_deposits_edit')
                },
                { name: 'file' },
                { name: 'printSalesPayment', role: true },
                { name: 'download', role: true },
                {
                  name: 'delete',
                  role: $checkRole('partners_deposits_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('allerts.Attention'),
            areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
            close: $t('allerts.close'),
            confirm: $t('allerts.confirm'),
            loading: $t('allerts.loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/partnersDeposits'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
